import {createSlice} from '@reduxjs/toolkit'

const userImagesList = createSlice({
    name: 'userImagesList',
    initialState: {
        userImagesList: [],
        assetsList: [],
        assetsShapesList: [],
        assetsTextList: []
    },
    reducers: {
        //UserImages
        setUrlsInNewImageList: (state, action) => {
            let { resImageFiles: newImageList, activeSheet } = action.payload;
            let tempImgCollection = [...state.userImagesList];

            tempImgCollection.forEach((img) => {
                if(img.imageUrl === '' && newImageList.length > 0) {
                    let newImage = newImageList.shift();
                    img.imageUrl = newImage.image;
                    img.thumbnail = newImage.thumbnail;
                    img.compressedUrl = newImage?.CompressedUrl;
                    img.id = newImage.id;
                    img.tag = newImage.Tags
                    img.loading = false;
                    img.progress = 100;
                }
            });

            state.userImagesList = tempImgCollection;
        },
        setProgressInNewImageList: (state, action) => {
            let {id, progress} = action.payload;
            let tempImgCollection = [...state.userImagesList];

            tempImgCollection.forEach((img) => {
                if(img.imageUrl === '' && img.uploadID === id) {
                    img.progress = progress;
                }
            });
            state.userImagesList = tempImgCollection;
        },
        setUserImagesList: (state, action) => {
            state.userImagesList = action.payload
        },
        deleteUserImagesItem: (state, action) => {
            state.userImagesList = state.userImagesList.filter(img => img.id !== action.payload)
        },

        //Assets

        setUrlsInNewAssetList: (state, action) => {
            const { resImageFiles: newImageList, type } = action.payload;
            let assetCollection;

            switch (type) {
                case 'image_graphic':
                    assetCollection = 'assetsList';
                    break;
                case 'text_graphic':
                    assetCollection = 'assetsTextList';
                    break;
                case 'shape':
                    assetCollection = 'assetsShapesList';
                    break;
                default:
                    assetCollection = 'assetsList';
                    break;
            }

            const tempAssetCollection = [...state[assetCollection]];

            tempAssetCollection.forEach((item) => {
                if (item.imageUrl === '' && newImageList.length > 0) {
                    const newImage = newImageList.shift();
                    item.imageUrl = newImage.image;
                    item.thumbnail = newImage.thumbnail;
                    item.id = newImage.id;
                    item.tag = newImage.Tags;
                    item.loading = false;
                    item.progress = 100;
                }
            });

            state[assetCollection] = tempAssetCollection;
        },
        setProgressInNewAssetList: (state, action) => {
            const { id, progress, type } = action.payload;
            let assetCollection;

            switch (type) {
                case 'image_graphic':
                    assetCollection = 'assetsList';
                    break;
                case 'text_graphic':
                    assetCollection = 'assetsTextList';
                    break;
                case 'shape':
                    assetCollection = 'assetsShapesList';
                    break;
                default:
                    assetCollection = 'assetsList';
                    break;
            }

            const tempAssetCollection = [...state[assetCollection]];
            tempAssetCollection.forEach((item) => {
                if (item.imageUrl === '' && item.uploadID === id) {
                    item.progress = progress;
                }
            });

            state[assetCollection] = tempAssetCollection;
        },
        setAssetList: (state, action) => {
            const { type, data } = action.payload;
            switch (type) {
                case 'image_graphic':
                    state.assetsList = data
                    break;
                case 'text_graphic':
                    state.assetsTextList = data
                    break;
                case 'shape':
                    state.assetsShapesList = data
                    break
                default:
                    state.assetsList = data
                    break;
            }
        },
        deleteAssetItem: (state, action) => {
            const { type, itemId } = action.payload;
            let assetCollection;

            switch (type) {
                case 'image_graphic':
                    assetCollection = 'assetsList';
                    break;
                case 'text_graphic':
                    assetCollection = 'assetsTextList';
                    break;
                case 'shape':
                    assetCollection = 'assetsShapesList';
                    break;
                default:
                    assetCollection = 'assetsList';
                    break;
            }
            state[assetCollection] = state[assetCollection].filter(item => item.id !== itemId);
        }
    }
});

export const {setUserImagesList, deleteUserImagesItem, setUrlsInNewImageList, setProgressInNewImageList, setUrlsInNewAssetList, setProgressInNewAssetList, setAssetList, deleteAssetItem} = userImagesList.actions;
export default userImagesList.reducer;
